<div class="fac__header">
  <admin-breadcrumbs></admin-breadcrumbs>

  <h3>Facilities Import</h3>

</div>

<div class="fac__body">

  <div class="fac__controls">
    
    <div class="fac__upload-wrapper">
      <input #fileInput class="fac__file-input" type="file" id="file-input"
        [attr.accept]="UPLOAD_CONFIG.acceptedTypes" (change)="onFileSelected($event)" />
      <button class="fac__upload-button btn btn-secondary btn-rounded btn-sm" for="file-input" (click)="fileInput.click()">
        <i class="fac__upload-icon fa fa-search"></i>Upload CSV File
      </button>
    </div>

  </div>

  <div class="fac__general-error">{{ generalError }}</div>

  <div *ngIf="!tableLoading; else loadingTpl" class="fac__table-container">

    <table class="fac__table">

      <thead>
        <tr class="fac__row">
          <th *ngFor="let column of columnConfigs" class="fac__th">
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody>
      <tr *ngFor="let row of facilitySettings; let index = index; trackBy: trackById" class="fac__row">
        <td *ngFor="let column of columnConfigs; trackBy: trackByKey" class="fac__td">
          <ng-container [ngSwitch]="column.template">

            <ng-container *ngSwitchCase="'checkboxTpl'">
              <form-field
                [config]="CHECKBOX_CONFIG_DEFAULT"
                [value]="row[column.key]"
                (onChange)="onValueChange($event, column.key, index)"
                [disabled]="column.key !== 'ownerActive' && !row.ownerActive">
              </form-field>
            </ng-container>
        
            <ng-container *ngSwitchCase="'textInputTpl'">
              <form-field
                [config]="TEXTINPUT_CONFIG_DEFAULT"
                [value]="row[column.key]"
                (onChange)="onValueChange($event, column.key, index)">
              </form-field>
            </ng-container>
        
            <ng-container *ngSwitchDefault>
              {{ row[column.key] }}
            </ng-container>
        
          </ng-container>
        </td>
      </tr>

      <tr *ngIf="!facilitySettings?.length" class="fac__row">
        <td class="fac__td" colspan="9">
          No facilities have been loaded yet.
        </td>
      </tr>
      </tbody>

    </table>

  </div>

</div>

<ng-template #loadingTpl>
  <div class="report__loading-state">
    <ngx-processing-anim [loader]="true"
      style="width: 17px; vertical-align: middle; padding-top: 5px; margin-left: 5px;"></ngx-processing-anim>
    Loading...
  </div>
</ng-template>

